import baseURL from '../baseURL';

export async function markPledgeTicketPrinted(pledgeId) {
  if (!pledgeId) return null;
  const token = localStorage.getItem('token');
  const res = await fetch(`${baseURL}/pledges/${pledgeId}/mark-printed`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Failed to mark pledge as printed');
  }
  return data;
}

export async function fetchTransferToAPreview(pledgeId, customerCode) {
  const token = localStorage.getItem('token');
  const qs =
    customerCode != null && String(customerCode).trim() !== ''
      ? `?customerCode=${encodeURIComponent(String(customerCode).trim())}`
      : '';
  const res = await fetch(`${baseURL}/pledges/transfer-to-a/preview/${pledgeId}${qs}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Failed to load transfer preview');
  }
  return data.data;
}

export async function transferPledgesToA(payload) {
  const token = localStorage.getItem('token');
  const body =
    Array.isArray(payload) || typeof payload === 'string'
      ? { pledgeIds: payload }
      : payload;
  const res = await fetch(`${baseURL}/pledges/transfer-to-a`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Transfer failed');
  }
  return data;
}

/** Clear stuck "Transferred" status on VPS B (e.g. after pledge deleted on VPS A). */
export async function clearTransferToA(pledgeId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${baseURL}/pledges/${pledgeId}/clear-transfer-to-a`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Failed to reset transfer status');
  }
  return data;
}
